import Vue from 'vue'
import Vuex from 'vuex'
import Cookie from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		// baseImgUrl: 'http://www.pumcp.org.cn',
		baseImgUrl: '',
		baseCourseImgUrl: 'https://cdn-hp.smedu.cn',
		// baseImgUrl: 'http://www.cert.com',
		token: Cookie.get('token') || '',
		refresh_token: Cookie.get('refresh_token') || '',
		stu_info: Cookie.get('stu_info') || '',
		mobile: false,
		code: Cookie.get('code') || '',
	},
	mutations: {
		SET_CODE(state, code) {
			Cookie.set('code', code);
			state.code = code
		},
		SET_TOKEN(state, token) {
			Cookie.set('token', token);
			state.token = token
		},
		SET_REFRESH_TOKEN(state, token) {
			Cookie.set('refresh_token', token);
			state.refresh_token = token
		},
		SET_STU_INFO(state, info) {
			Cookie.set('stu_info', info);
			state.stu_info = info
		},
		LOGOUT(state) {
			Cookie.remove('token');
			Cookie.remove('refresh_token');
			// Cookie.remove('stu_info');
			state.token = ''
			state.refresh_token = ''
			// state.stu_info = {}
		},
		SET_PLATFORM(state, info) {
			state.mobile = info
		}
	},
	actions: {
		setToken(context, params) {
			context.commit('SET_TOKEN', params)
			context.commit('SET_CODE', '')
		},
		setRefreshToken(context, params) {
			context.commit('SET_REFRESH_TOKEN', params)
		},
		setStuInfo(context, params) {
			context.commit('SET_STU_INFO', params)
		},
		logout(context) {
			context.commit('LOGOUT')
			context.commit('SET_CODE', '')
		}
	},
	getters: {
		code: state => {
			return state.code
		},
		baseImgUrl: state => {
			return state.baseImgUrl
		},
		baseCourseImgUrl: state => {
			return state.baseCourseImgUrl
		},
		getToken: state => {
			return state.token
		},
		getRefreshToken: state => {
			return state.refresh_token
		},
		getStuInfo: state => {
			return state.stu_info
		},
		isMobile: state => {
			return state.mobile
		},
		isPc: state => {
			return !state.mobile
		}
	},
	modules: {}
})
